<app-form-modal
  [title]="isEditMode ? 'ADMIN.USERS.EDIT_TITLE' : 'ADMIN.USERS.CREATE_TITLE'"
  [loading]="loading"
  [formGroup]="form"
  [errorMessage]="errorMessage"
  [closeText]="'CANCEL'"
  [submitText]="'SAVE'"
  (submitClicked)="save()">
  <div class="row g-2">
      <div class="col-md-6">
        <app-form-input
          id="create-user-username"
          label="ADMIN.USERS.USERNAME_PLACEHOLDER"
          controlName="username"
          [formGroup]="form"
          [isRequired]="true" />
                @for (error of getErrors('username'); track error) {
          <app-validation-error [text]="error" />
        }
      </div>
      <div class="col-md-6">
        <app-form-input
          id="create-user-email"
          label="ADMIN.USERS.EMAIL_PLACEHOLDER"
          controlName="email"
          [formGroup]="form" />
                @for (error of getErrors('email'); track error) {
          <app-validation-error [text]="error" />
        }
      </div>
      <div class="col-md-6">
        <app-enum-select
          [formGroup]="form"
          controlName="role"
          [enum]="roleOptions"
          [label]="'ROLE'"
          [isRequired]="true"
          [castFunction]="roleLabelKey"
        />
      </div>
      <div class="col-md-6 d-flex align-items-end pb-2">
        <app-checkbox-input
          id="create-user-active"
          label="ADMIN.USERS.ACTIVE"
          controlName="active"
          [formGroup]="form" />
      </div>
    </div>
</app-form-modal>
